const VALID_REACT_DOM_EVENTS = new Set<string>([
  "onCopy",
  "onCut",
  "onPaste",
  "onCompositionEnd",
  "onCompositionStart",
  "onCompositionUpdate",
  "onKeyDown",
  "onKeyPress",
  "onKeyUp",
  "onFocus",
  "onBlur",
  "onChange",
  "onInput",
  "onInvalid",
  "onReset",
  "onSubmit",
  "onClick",
  "onContextMenu",
  "onDoubleClick",
  "onDrag",
  "onDragEnd",
  "onDragEnter",
  "onDragExit",
  "onDragLeave",
  "onDragOver",
  "onDragStart",
  "onDrop",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onSelect",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onScroll",
  "onWheel",
  "onAbort",
  "onCanPlay",
  "onCanPlayThrough",
  "onDurationChange",
  "onEmptied",
  "onEncrypted",
  "onEnded",
  "onError",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onPause",
  "onPlay",
  "onPlaying",
  "onProgress",
  "onRateChange",
  "onSeeked",
  "onSeeking",
  "onStalled",
  "onSuspend",
  "onTimeUpdate",
  "onVolumeChange",
  "onWaiting",
  "onLoad"
]);

const ALWAYS_ALLOWED_DOM_PROPS = new Set<string>([
  "className",
  "style",
  "id",
  "role",
  "title",
  "tabIndex",
  "htmlFor",
  "value",
  "defaultValue",
  "checked",
  "defaultChecked",
  "disabled",
  "type",
  "name",
  "placeholder",
  "src",
  "srcSet",
  "alt",
  "href",
  "target",
  "rel",
  "download",
  "width",
  "height",
  "viewBox",
  "xmlns",
  "fill",
  "stroke",
  "d",
  "x",
  "y",
  "cx",
  "cy",
  "r",
  "x1",
  "y1",
  "x2",
  "y2",
  "preserveAspectRatio",
  "dangerouslySetInnerHTML"
]);

function normalizeDomEventName(key: string): string {
  if (key === "onContextmenu") return "onContextMenu";
  if (key === "onDblclick") return "onDoubleClick";
  if (key === "onMousedown") return "onMouseDown";
  if (key === "onMouseup") return "onMouseUp";
  if (key === "onMousemove") return "onMouseMove";
  if (key === "onMouseenter") return "onMouseEnter";
  if (key === "onMouseleave") return "onMouseLeave";
  if (key === "onTouchstart") return "onTouchStart";
  if (key === "onTouchend") return "onTouchEnd";
  if (key === "onTouchmove") return "onTouchMove";
  if (key === "onKeydown") return "onKeyDown";
  if (key === "onKeyup") return "onKeyUp";
  if (key === "onKeypress") return "onKeyPress";
  return key;
}

export function filterDomProps(input: unknown): unknown {
  if (!input || typeof input !== "object") return input;

  const source = input as Record<string, unknown>;
  const out: Record<string, unknown> = {};
  const domProbe =
    typeof document !== "undefined" && document.createElement
      ? document.createElement("div")
      : null;

  for (const key of Object.keys(source)) {
    if (key === "key" || key === "ref" || key === "children") continue;

    const value = source[key];
    const normalizedKey = normalizeDomEventName(key);

    if (normalizedKey.startsWith("data-") || normalizedKey.startsWith("aria-")) {
      out[normalizedKey] = value;
      continue;
    }

    if (/^on[A-Z]/.test(normalizedKey)) {
      if (VALID_REACT_DOM_EVENTS.has(normalizedKey)) out[normalizedKey] = value;
      continue;
    }

    if (ALWAYS_ALLOWED_DOM_PROPS.has(normalizedKey)) {
      out[normalizedKey] = value;
      continue;
    }

    if (/^[a-z][a-z0-9-]*$/.test(normalizedKey)) {
      out[normalizedKey] = value;
      continue;
    }

    if (/[A-Z]/.test(normalizedKey)) {
      if (domProbe && normalizedKey in domProbe) out[normalizedKey] = value;
      continue;
    }

    out[normalizedKey] = value;
  }

  return out;
}
